module.exports = __webpack_public_path__ + "img/本科.1c626986.jpg";